
import Component, { mixins } from 'vue-class-component';
import WidgetMixins from '../../../mixins/WidgetMixins';
import DialogMixins from '../../../mixins/DialogMixins';
import { loadWidget } from '@/utils/helpers';
import { Getter, namespace } from 'vuex-class';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { alpha_num, required } from 'vee-validate/dist/rules';
import { IUser } from '@/types/types';
const auth = namespace('auth');
extend('required', {
  ...required,
  message: `Field is required`,
});
extend('alpha_num', {
  ...alpha_num,
  message: 'Invalid input provided. Only alphanumeric characters are allowed.',
});
@Component({
  name: 'Index',
  components: {
    InternetConnection: loadWidget('pages/InternetConnection'),
    ToolBar: loadWidget('widgets/ToolBar'),
    SnackBar: loadWidget('widgets/SnackBar'),
    EmptyPage: loadWidget('pages/EmptyPage'),
    ProgressBar: loadWidget('widgets/CircularProgressLoader'),
    ValidationProvider,
    ValidationObserver,
  },
  filters: {},
})
export default class Index extends mixins(WidgetMixins, DialogMixins) {
  @Getter('getCreditBalance') creditBalance!: number;
  @auth.Getter('getUserDetails') details!: IUser;

  feedback = {
    title: '',
    content: '',
  };

  sendFeedback(): void {
    this.$store.dispatch('log/feedback', { ...this.feedback });
  }
}
